import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=7b073d7d&scoped=true&"
import script from "./Bills.vue?vue&type=script&lang=js&"
export * from "./Bills.vue?vue&type=script&lang=js&"
import style0 from "./Bills.vue?vue&type=style&index=0&id=7b073d7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b073d7d",
  null
  
)

export default component.exports